import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-grants-execution',
  templateUrl: './grants-execution.component.html',
  styleUrls: ['./grants-execution.component.scss']
})
export class GrantsExecutionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
